/**
 * @description 문자열에서 이모지를 제거하는 함수
 *
 * 수령장소/출입방법 상세는 한글/영문/숫자/특수문자/공백은 허용하고 이모지만 제거한다(정책).
 * 모든 픽토그램(Extended_Pictographic)과 조합 문자(피부톤·지역표시자·FE0F·ZWJ·키캡)를 코드포인트 기준으로 제거한다.
 * 렌더링이 아닌 코드포인트로 판정하므로, Chrome 폰트 폴백으로 컬러 이모지처럼 보이는 맨 픽토그램(✝ ☠ 등)도 차단된다.
 * 단, 유니코드가 이모지로 분류하지만 정책상 허용하는 기호는 allowlist로 보존한다
 * (정책 명시 특문 + 상용 흑백 기호 ©®™; FE0F가 붙어도 조합 문자만 제거되어 텍스트로 남는다).
 * @returns 이모지가 제거된 문자열
 */
const PRESERVED_SYMBOLS = new Set('★↔◀▶♤♠♡♥♧♣♨☏☎©®™');

const EMOJI_REGEX = /\p{Extended_Pictographic}|\p{Emoji_Modifier}|\p{Regional_Indicator}|\u{FE0F}|\u{200D}|\u{20E3}/gu;

const removeEmoji = (value: string) => value.replace(EMOJI_REGEX, (char) => (PRESERVED_SYMBOLS.has(char) ? char : ''));

export default removeEmoji;
